import React, { useRef, useState } from "react";

import ReactToPrint from "react-to-print";
import { format } from "date-fns";

import { AiOutlinePrinter } from "react-icons/ai";

import { Icon, MenuItem, Text } from "@chakra-ui/react";

import { ComponentToPrintCrianca } from "../ComponentToPrintCrianca";
import CriancaService from "../../../main/services/CriancaService";
import { FaDownload } from "react-icons/fa";
import { cpf } from "../../utils/masks";

export const PrintMenuItemCrianca = ({ idCrianca }) => {
  const componentToPrintRef = useRef(null);

  const [data, setData] = useState();
  const [imagem, setImagem] = useState("");
  const [columnsRegistro, setColumnsRegistro] = useState([]);
  const [columnsIdentidade, setColumnsIdentidade] = useState([]);
  const [columnsCPF, setColumnsCPF] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const beforeGetContent = async () => {
    setIsLoading(true);
    try {
      const res = await CriancaService.dadosImpressaoCrianca(idCrianca);

      const { movimentacoes, ...resto } = res.data;

      const tempMovimentacoes = movimentacoes.sort((a, b) => {
        const dateA = new Date(a.dataMovimentacao);
        const dateB = new Date(b.dataMovimentacao);
        const truncatedDateA = new Date(
          dateA.getFullYear(),
          dateA.getMonth(),
          dateA.getDate()
        );
        const truncatedDateB = new Date(
          dateB.getFullYear(),
          dateB.getMonth(),
          dateB.getDate()
        );

        if (truncatedDateB - truncatedDateA !== 0) {
          return truncatedDateB - truncatedDateA;
        } else {
          return b.id - a.id;
        }
      });

      if (res.data) {
        const anexos = res?.data?.anexos?.filter(
          (item) => item?.categoriaAnexo?.id === 1
        );
        anexos &&
          anexos?.sort(
            (a, b) => new Date(b.dataUpload) - new Date(a.dataUpload)
          );

        await CriancaService.getAnexo(res.data.idAnexoFoto, "visualizar")
          .then((res) => {
            setImagem(res.config.url);
          })
          .catch((error) => {
            setImagem("");
            console.log(error);
          });
      }

      if (res.data) {
        if (res?.data?.documentacao?.numeroSolicitacaoCertNascimento) {
          setColumnsRegistro([
            {
              Header: "Matrícula",
              accessor: "matricula",
              Cell: (props) => {
                return (
                  <span title={props.value}>
                    {props.value ? props.value : ""}
                  </span>
                );
              },
            },
            {
              Header: "Livro",
              accessor: "livro",
              Cell: (props) => {
                return <span>{props.value ? props.value : ""}</span>;
              },
            },
            {
              Header: "Folha",
              accessor: "folha",
              Cell: (props) => {
                return <span>{props.value ? props.value : ""}</span>;
              },
            },
            {
              Header: "Termo",
              accessor: "termo",
              Cell: (props) => {
                return <span>{props.value ? props.value : ""}</span>;
              },
            },
            {
              Header: "Arquivo",
              accessor: "certidao",
              Cell: (props) => {
                return (
                  <span>
                    {props.value && (
                      <Icon
                        aria-label="Download"
                        color="#006064"
                        as={FaDownload}
                        boxSize="18px"
                        _hover={{ cursor: "pointer" }}
                      />
                    )}
                  </span>
                );
              },
            },
          ]);
        } else {
          setColumnsRegistro([
            {
              Header: "Matrícula",
              accessor: "matricula",
              Cell: (props) => {
                return (
                  <span title={props.value}>
                    {props.value ? props.value : ""}
                  </span>
                );
              },
            },
            {
              Header: "Livro",
              accessor: "livro",
              Cell: (props) => {
                return <span>{props.value ? props.value : ""}</span>;
              },
            },
            {
              Header: "Folha",
              accessor: "folha",
              Cell: (props) => {
                return <span>{props.value ? props.value : ""}</span>;
              },
            },
            {
              Header: "Termo",
              accessor: "termo",
              Cell: (props) => {
                return <span>{props.value ? props.value : ""}</span>;
              },
            },
            {
              Header: "Arquivo",
              accessor: "certidao",
              Cell: (props) => {
                return (
                  <span>
                    {props.value && (
                      <Icon
                        aria-label="Download"
                        color="#006064"
                        as={FaDownload}
                        boxSize="18px"
                        _hover={{ cursor: "pointer" }}
                      />
                    )}
                  </span>
                );
              },
            },
          ]);
        }
        if (res?.data?.documentacao?.numeroSolicitacaoIdentidade) {
          setColumnsIdentidade([
            {
              Header: "Nº da identidade",
              accessor: "numeroIdentidade",
              Cell: (props) => {
                return (
                  <span title={props.value}>
                    {props.value ? props.value : ""}
                  </span>
                );
              },
            },
            {
              Header: "Órgão Expedidor",
              accessor: "orgaoExpedidor",
              Cell: (props) => {
                return <span>{props.value ? props.value : ""}</span>;
              },
            },
            {
              Header: "Data de expedição",
              accessor: "dataExpedicaoIdentidade",
              Cell: (props) => {
                return (
                  <span>
                    {props.value ? format(props.value, "dd/MM/yyyy") : ""}
                  </span>
                );
              },
            },
            {
              Header: "Arquivo",
              accessor: "identidade",
              Cell: (props) => {
                return (
                  <span>
                    {props.value && (
                      <Icon
                        aria-label="Download"
                        color="#006064"
                        as={FaDownload}
                        boxSize="18px"
                        _hover={{ cursor: "pointer" }}
                      />
                    )}
                  </span>
                );
              },
            },
          ]);
        } else {
          setColumnsIdentidade([
            {
              Header: "Nº da identidade",
              accessor: "numeroIdentidade",
              Cell: (props) => {
                return (
                  <span title={props.value}>
                    {props.value ? props.value : ""}
                  </span>
                );
              },
            },
            {
              Header: "Órgão Expedidor",
              accessor: "orgaoExpedidor",
              Cell: (props) => {
                return <span>{props.value ? props.value : ""}</span>;
              },
            },
            {
              Header: "Data de expedição",
              accessor: "dataExpedicaoIdentidade",
              Cell: (props) => {
                return (
                  <span>
                    {props.value ? format(props.value, "dd/MM/yyyy") : ""}
                  </span>
                );
              },
            },
            {
              Header: "Arquivo",
              accessor: "identidade",
              Cell: (props) => {
                return (
                  <span>
                    {props.value && (
                      <Icon
                        aria-label="Download"
                        color="#006064"
                        as={FaDownload}
                        boxSize="18px"
                        _hover={{ cursor: "pointer" }}
                      />
                    )}
                  </span>
                );
              },
            },
          ]);
        }
        if (res?.data?.documentacao?.numeroSolicitacaoCPF) {
          setColumnsCPF([
            {
              Header: "Nº do CPF",
              accessor: "cpf",
              Cell: (props) => {
                return (
                  <span title={props.value}>
                    {props.value ? cpf(props.value) : ""}
                  </span>
                );
              },
            },
            {
              Header: "Arquivo",
              accessor: "anexoCpf",
              Cell: (props) => {
                return (
                  <span>
                    {props.value && (
                      <Icon
                        aria-label="Download"
                        color="#006064"
                        as={FaDownload}
                        boxSize="18px"
                        _hover={{ cursor: "pointer" }}
                      />
                    )}
                  </span>
                );
              },
            },
          ]);
        } else {
          setColumnsCPF([
            {
              Header: "Nº do CPF",
              accessor: "cpf",
              Cell: (props) => {
                return (
                  <span title={props.value}>
                    {props.value ? cpf(props.value) : ""}
                  </span>
                );
              },
            },
            {
              Header: "Arquivo",
              accessor: "anexoCpf",
              Cell: (props) => {
                return (
                  <span>
                    {props.value && (
                      <Icon
                        aria-label="Download"
                        color="#006064"
                        as={FaDownload}
                        boxSize="18px"
                        _hover={{ cursor: "pointer" }}
                      />
                    )}
                  </span>
                );
              },
            },
          ]);
        }
      }

      setData({ movimentacoes: tempMovimentacoes, ...resto });

      setIsLoading(false);
    } catch (erro) {
      console.log("Erro ao acessar os dados de impressao");
      console.log(erro);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const customPageStyle = `
    @page { 
      size: auto;  
      margin-top: 0mm; 
      margin-bottom: 10mm; 
    } 
    @media print { 
      body { 
        -webkit-print-color-adjust: exact; 
      } 
    }
  `;

  return (
    <>
      <ReactToPrint
        onBeforeGetContent={beforeGetContent}
        onAfterPrint={() => setIsLoading(false)}
        documentTitle={data && `MCA - ${data.nome}`}
        pageStyle={customPageStyle}
        trigger={() => {
          return (
            <MenuItem color={"#374BCE"} p={2}>
              <AiOutlinePrinter />
              <Text ml="5px">Imprimir</Text>
            </MenuItem>
          );
        }}
        content={() => componentToPrintRef.current}
      />
      <div style={{ display: "none" }}>
        {!isLoading && (
          <ComponentToPrintCrianca
            ref={componentToPrintRef}
            data={data ? data : null}
            dataDocumentacao={data ? data.documentacao : null}
            imagem={imagem}
            setImagem={setImagem}
            columnsRegistro={columnsRegistro}
            columnsIdentidade={columnsIdentidade}
            columnsCPF={columnsCPF}
            dataHistoricoMovimentacao={data ? data.movimentacoes : null}
            dataReferenciaFamiliar={data ? data.referenciasFamiliar : null}
            dataGuarda={data?.guarda ? [data.guarda] : null}
            dataSaude={data ? data.saude : null}
            dataEducacao={data ? data.educacao : null}
            dataProfissionalizacao={data ? data.profissionalizacao : null}
            dataOcorrencia={data ? data.ocorrencias : null}
            dataVisita={data ? data.visitasContadores : null}
            dataRestricoes={data ? data.restricoes : null}
            dataIrmaos={data ? data.irmaos : null}
            dataProcessoProcedimento={data ? data.processosProcedimentos : null}
            dataAdocao={data ? data.situacaoAdocao : null}
            dataEntregaVoluntaria={data ? data.entregaVoluntaria : null}
            dataAtribuicaoCompetencia={data ? data.atribuicaoCompetencia : null}
            dataApadrinhamento={data ? data.programaApadrinhamento : null}
            dataApadrinhamentoHistorico={
              data ? data.programaApadrinhamentoHistorico : null
            }
            dataAnexos={
              data
                ? data?.anexos?.sort(
                    (a, b) => new Date(b.dataUpload) - new Date(a.dataUpload)
                  )
                : null
            }
            dataHouveExtincao={data ? data.houveExtincaoPoderFamiliar : null}
            idCrianca={idCrianca}
          />
        )}
      </div>
    </>
  );
};
